/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime : 2022-07-27 14:39:12
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\smart\stocksake.js
 */
/*
 * @Description: 库存管理接口
 * @Author: wangwangwang
 * @Date: 2020-11-20 10:27:35
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-05-13 18:50:47
 */
export const queryPage = "/icps/system/sign/basics/inventory/raw_detail";
import request from "@/utils/request";
export function saveOrUpdate(data) {
  return request({
    url: "/icps/system/sign/basics/inventory/save_Raw_inventory",
    method: "post",
    data,
  });
}
/*盘点价格*/
export function update_stock_price(data) {
  return request({
    url: "/icps/system/sign/basics/inventory/update_stock_price",
    method: "post",
    data,
  });
}
/*盘点库存*/
export function update_check_inventory(data) {
  return request({
    url: "/icps/system/sign/basics/inventory/update_check_inventory",
    method: "post",
    data,
  });
}
/*获取库存明细*/
export function inventory_detail(data) {
  return request({
    url: "/icps/system/sign/basics/inventory/inventory_detail ",
    method: "post",
    data,
  });
}
/*获取盘点记录*/
export function check_detail(data) {
  return request({
    url: "/icps/system/sign/basics/inventory/check_detail",
    method: "post",
    data,
  });
}
/*获取公司当前层级的站点*/
export function get_station_list(params) {
  return request({
    url: "/base/system/base/organization/get_station_list",
    method: "get",
    params,
  });
}
/*物料调拨*/
export function update_raw_allocation(data) {
  return request({
    url: "/icps/system/sign/basics/inventory/update_raw_allocation",
    method: "post",
    data,
  });
}
/*获取原物料列表*/
export function selectRoles(data) {
  return request({
    url: "/icps/system/sign/basics/warehouse/selectRoles",
    method: "post",
    data,
  });
}
/*查询仓库下的原物料数量*/
export function getStockNumber(data) {
  return request({
    url: "/icps/system/sign/basics/inventory/get_stock",
    method: "post",
    data,
  });
}
/*查询仓库下的原物料数量*/
export function queryTransferPage(data) {
  return request({
    url: "/icps/system/sign/intelligent/inventory/transfer/queryTransferPage",
    method: "post",
    data,
  });
}
/*删除*/
export function updateInventory(data) {
  return request({
    url: "/icps/system/sign/basics/inventory/updateInventory",
    method: "post",
    data,
  });
}
/*获取原物料列表*/
export function queryListByCompanyId(data) {
  return request({
    url: "/icps/system/sign/basics/rawMaterials/queryListByCompanyId",
    method: "post",
    data,
  });
}